import React from 'react';
import { styled } from 'linaria/react';
import { useQuery } from 'react-apollo';
import SectionWrapper from '../../../Layout/SectionWrapper';
import Image from '../components/Image';
import LoadingPage from '../../../LoadingPage';
import FeaturedProductQuery from '../../../ProductPage/FeaturedProduct.gql';
import { theme } from '../../../Theme';
import FeaturedProductCard from '../components/FeaturedProductCard';

const ProductHighlightWrapper = styled(SectionWrapper)`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
`;

const ContentWrapper = styled('div')`
  display: flex;
  padding-top: 80px;
  padding-bottom: 80px;
  justify-content: ${({ layout }) =>
    layout === 'loose' ? 'space-between' : 'center'};
  align-items: flex-start;
  padding-left: ${({ layout }) => (layout === 'loose' ? '32px' : '205px')};
  padding-right: ${({ layout }) => (layout === 'loose' ? '32px' : '205px')};
  gap: ${({ layout }) => (layout === 'tight' ? '8px' : '0px')};
  flex-wrap: wrap;

  ${theme.below.xl} {
    padding-left: 32px;
    padding-right: 32px;
  }

  ${theme.below.lg} {
    gap: ${({ layout }) => (layout === 'loose' ? '32px' : '8px')};
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: flex-end;
    gap: 100px;
  }
`;

const ImageWrapper = styled('div')`
  position: relative;
  max-width: ${({ layout }) => (layout === 'tight' ? '680px' : '770px')};
  width: 100%;
  height: auto;
  aspect-ratio: ${({ ratio }) => (ratio === '4:5' ? '4 / 5' : '1 / 1')};
`;

const TextWrapper = styled('div')`
  margin-top: 0.5rem;
  color: ${theme.colors.black};
  text-align: left;
  font-size: 14px;
  max-width: 342px;
  max-height: 80px;
`;

const ProductWrapper = styled('div')`
  width: 335px;

  ${theme.below.lg} {
    width: 60%;
  }
`;

const ProductHighlight = ({ media, ratio, layout, product, text, order }) => {
  const articleNumber = product?.[0]?.article_number;
  const { loading, data, error } = useQuery(FeaturedProductQuery, {
    variables: { id: articleNumber }
  });

  if (loading) return <LoadingPage />;
  if (error) throw Error(error);

  const productData = data?.product;

  return (
    <ProductHighlightWrapper>
      <ContentWrapper layout={layout}>
        {order === 'product_first' ? (
          <>
            <ProductWrapper>
              <FeaturedProductCard product={productData} />
            </ProductWrapper>
            <ImageWrapper ratio={ratio} layout={layout}>
              <Image
                fillAvailableSpace
                src={media?.filename || 'fallback-image.jpg'}
                alt={media?.alt || 'No image available'}
              />
              <TextWrapper>{text}</TextWrapper>
            </ImageWrapper>
          </>
        ) : (
          <>
            <ImageWrapper ratio={ratio} layout={layout}>
              <Image
                fillAvailableSpace
                src={media?.filename || 'fallback-image.jpg'}
                alt={media?.alt || 'No image available'}
              />
              <TextWrapper>{text}</TextWrapper>
            </ImageWrapper>
            <ProductWrapper>
              <FeaturedProductCard product={productData} />
            </ProductWrapper>
          </>
        )}
      </ContentWrapper>
    </ProductHighlightWrapper>
  );
};

export default ProductHighlight;
